import {TableNode} from '@table-library/react-table-library'
import {useTheme} from '@table-library/react-table-library/theme'
import {Theme} from '@table-library/react-table-library/types/theme'
import {DataTableProps} from '../model'
import {useDataTableDefaultColorTheme} from './use-default-color-theme'
import {useDataTableDimensionsTheme} from './use-dimensions-theme'

export function useDataTableTheme<ColumnID extends string, ITEM extends TableNode>({
  columns,
  height,
  theme,
}: DataTableProps<ColumnID, ITEM>): Theme {
  const colorTheme = useDataTableDefaultColorTheme()
  const dimensionsTheme = useDataTableDimensionsTheme(columns, height)
  return useTheme(theme
    ? [colorTheme, dimensionsTheme, theme]
    : [colorTheme, dimensionsTheme],
  )
}